import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { Container, Name } from './ImageCardStyles';

const shimmerStyle = css`
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: linear-gradient(90deg, transparent 0, ${cbSemanticCssVars.surfaceMain} 80%, transparent);
    animation: shimmer 1200ms infinite;
    opacity: 0.7;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
`;

const ContainerSkeleton = styled(Container)`
  ${shimmerStyle}
  justify-content: end;
`;

const NameSkeleton = styled(Name)`
  height: 32px;
`;

export const ImageCardSkeleton = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <ContainerSkeleton ref={ref}>
      <NameSkeleton />
    </ContainerSkeleton>
  );
});
